import { getRoutePathById, allSiteMap } from '@bingads-webui-react/with-site-map';
import _ from 'underscore';

export function buildQueryString(params, scope) {
  return params.reduce((result, param) => {
    const value = _.get(scope, ['values', param]);
    if (value != null) {
      return result.concat(`${param}=${value}`);
    }
    return result;
  }, []).join('&');
}

export function getFullProductUrl(routeName, scope, extraParams = []) {
  const baseParams = ['aid', 'cid', 'uid'];
  const params = baseParams.concat(extraParams);
  const pathname = getRoutePathById(allSiteMap, routeName);
  const search = buildQueryString(params, scope);

  return `${pathname}?${search}`;
}

interface messageType {
  currentMessages: string[]
  suggestedMessages: string[]
}
export const generateEventGoalFixMessage = (i18n, parmas) => {
  const outputMessage: messageType = { currentMessages: [], suggestedMessages: [] };
  if (parmas.CurrentEventCategory && parmas.CurrentEventCategoryOperator) {
    outputMessage.currentMessages.push(i18n.getString(_TL_('"category {{CurrentEventCategoryOperator}} {{CurrentEventCategory}}"'), parmas));
  }
  if (parmas.CurrentEventAction && parmas.CurrentEventActionOperator) {
    outputMessage.currentMessages.push(i18n.getString(_TL_('"action {{CurrentEventActionOperator}} {{CurrentEventAction}}"'), parmas));
  }
  if (parmas.CurrentEventLabel && parmas.CurrentEventLabelOperator) {
    outputMessage.currentMessages.push(i18n.getString(_TL_('"label {{CurrentEventLabelOperator}} {{CurrentEventLabel}}"'), parmas));
  }
  if (parmas.CurrentEventValue && parmas.CurrentEventValueOperator) {
    outputMessage.currentMessages.push(i18n.getString(_TL_('"value {{CurrentEventValueOperator}} {{CurrentEventValue}}"'), parmas));
  }

  // populate for suggested
  if (parmas.SuggestedEventCategory && parmas.SuggestedEventCategoryOperator) {
    outputMessage.suggestedMessages.push(i18n.getString(_TL_('"category {{SuggestedEventCategoryOperator}} {{SuggestedEventCategory}}"'), parmas));
  }
  if (parmas.SuggestedEventAction && parmas.SuggestedEventActionOperator) {
    outputMessage.suggestedMessages.push(i18n.getString(_TL_('"action {{SuggestedEventActionOperator}} {{SuggestedEventAction}}"'), parmas));
  }
  if (parmas.SuggestedEventLabel && parmas.SuggestedEventLabelOperator) {
    outputMessage.suggestedMessages.push(i18n.getString(_TL_('"label {{SuggestedEventLabelOperator}} {{SuggestedEventLabel}}"'), parmas));
  }
  if (parmas.SuggestedEventValue && parmas.SuggestedEventValueOperator) {
    outputMessage.suggestedMessages.push(i18n.getString(_TL_('"value {{SuggestedEventValueOperator}} {{SuggestedEventValue}}"'), parmas));
  }
  return { current: outputMessage.currentMessages.join(', '), suggested: outputMessage.suggestedMessages.join(', ') };
};
